const __filename = "/app/views/therapists/show+desktop.js", __dirname = "/app/views/therapists";
import '/lib/definitions.js'

import start from '/lib/therapist_profile/desktop.js'

start()
